import { Tooltip } from '@mui/material';

function buildQueryString(params) {
  const query_params = new URLSearchParams();

  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      query_params.append(key, params[key]);
    }
  }

  const queryString = query_params.toString();
  console.log('Query String:', queryString);
  return queryString;
}

 function renderTruncatedWithTooltip(value) {
  if (typeof value !== 'string') return value;

  const short = value.split('_').pop(); // get last segment

  return (
    <Tooltip title={value}>
      <span>{short}</span>
    </Tooltip>
  );
}

export function  getCurrentWeekDates() {
  const today = new Date();

  // Find Monday
  const startDate = new Date(today);
  const day = startDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const diffToMonday = day === 0 ? 6 : day - 1; // if Sunday, go back 6 days
  startDate.setDate(startDate.getDate() - diffToMonday);

  // Find Sunday
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6);

  // Format dates as YYYY-MM-DD
  const formatDate = (date) => date.toISOString().slice(0, 10);

  const formattedStart = formatDate(startDate);
  const formattedEnd = formatDate(endDate);

  // console.log('Current week start date calculated :', formattedStart);
  // console.log('Current week end date: calculated', formattedEnd);

  return {
     formattedStart,
     formattedEnd
  };
}
export function getPdfDownloadName(location, wo, startDate, endDate) {

  const prefix = 'PROD_SCHEDULE';
  const safeLocation = location ? location.replace(/\s+/g, '_') : '';
  const wOrder = wo ? wo.replace(/\s+/g, '_') : '';
  const start = startDate ? new Date(startDate).toISOString().slice(0, 10) : '';
  const end = endDate ? new Date(endDate).toISOString().slice(0, 10) : '';

  

  return `${prefix}_${safeLocation}_${wOrder}_${start}_to_${end}.pdf`;

}

export function getDayLag(expectedQuantityArray,actualProducedArray,lagDay) {
  // process the lag for each day
  // total target - actual produced till date -> cummulative data to fetch day level lag 
  let expectedQuantity = 0;
  let actualProduced = 0;
   if(expectedQuantityArray[lagDay]===0)return '';
    // if(actualProducedArray[lagDay]===0)return '';
    if(lagDay<0 )return '';

  for(let i=0;i<=lagDay;i++){

    expectedQuantity = expectedQuantity + expectedQuantityArray[i];
    actualProduced = actualProduced + actualProducedArray[i];
  }
  const lag = actualProduced - expectedQuantity ;
    // console.log('lag',lag);
  return lag;
}

export function flag_line(lags) {
  console.log('lags',lags);
  console.log('lags',lags[lags.length - 1]);
  if (lags.length > 0 && lags[lags.length - 1] < 0) {
  
    return 'LAG';
  }
  // console.log('X');
  return '';
}

export { buildQueryString, renderTruncatedWithTooltip };